(function () {
  'use strict';

  var desktopQuery = window.matchMedia('(min-width: 1200px)');

  function applyResponsiveView() {
    var container = document.getElementById('ProductGridContainer');
    if (!container) return;
    container.classList.toggle('lmp-view-list', desktopQuery.matches);
    container.classList.toggle('lmp-view-grid', !desktopQuery.matches);
  }

  function init() {
    applyResponsiveView();

    if (desktopQuery.addEventListener) {
      desktopQuery.addEventListener('change', applyResponsiveView);
    } else {
      desktopQuery.addListener(applyResponsiveView);
    }

    var productArea = document.querySelector('.lmp-product-area');
    if (productArea) {
      var observer = new MutationObserver(function () {
        window.requestAnimationFrame(applyResponsiveView);
      });
      observer.observe(productArea, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* LMP: Dynamische Header-Unterkante fuer Filter-Drawer */
(function () {
  var ticking = false;
  function updateHeaderBottom() {
    var header = document.querySelector('.section-header');
    if (!header) return;
    var bottom = header.getBoundingClientRect().bottom;
    document.documentElement.style.setProperty('--lmp-header-bottom', Math.max(0, bottom) + 'px');
  }
  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        updateHeaderBottom();
        ticking = false;
      });
      ticking = true;
    }
  }
  document.addEventListener('DOMContentLoaded', updateHeaderBottom);
  window.addEventListener('load', updateHeaderBottom);
  window.addEventListener('resize', updateHeaderBottom);
  window.addEventListener('scroll', onScroll, { passive: true });
})();
